import Assert from "tbAssert";
import AuthConstants from "./AuthConstants";
import TbLoginViewModuleConstants from "tbClient/views/tb-login-view/Constants";

import UiRouterModule from "@uirouter/angularjs";
import TbAppConfigDataServiceModule from "tbClient/config/tb-app-config/TbAppConfigDataService";

const NotAuthorizedState = TbLoginViewModuleConstants.rootStateName;

class IdTokenClaimsInterceptor {
    constructor($log, $state, TbAppConfigDataService) {
        Assert.StrictAssert($log != null, "id token claims injector missing log service dependency");
        Assert.StrictAssert($state != null, "id token claims injector missing $state service");
        Assert.StrictAssert(TbAppConfigDataService != null, "id token claims injector missing app config data service");

        this._logSvc = $log;
        this._stateSvc = $state;
        const serverBaseUrl = TbAppConfigDataService.tbServerBaseUrl;
        this._apiBaseUrl = `${serverBaseUrl}/api/`;

        this.request = (config) => this.handleRequest(config);
        this.responseError = (rejection) => this.handleResponseError(rejection);
    }

    handleRequest(config) {
        const apiBaseUrl = this._apiBaseUrl;
        // Only add ID token header for API requests (Authorization header handled by jwtInterceptor)
        if (config.url && config.url.startsWith(apiBaseUrl)) {
            try {
                const idToken = localStorage.getItem(AuthConstants.storageKeys.idTokenKey);
                if (idToken) {
                    this._logSvc.debug("attaching id token to tb api request");
                    config.headers["X-ID-Token"] = idToken;
                }
            } catch (error) {
                this._logSvc.error("Error adding ID token to request:", error);
            }
        }

        return config;
    }

    handleResponseError(rejection) {
        // Handle 401/403 responses by redirecting to login
        if (rejection.status === 401 || rejection.status === 403) {
            try {
                if (this._stateSvc) {
                    const params = {
                        reason: rejection.status === 401 ? "expired" : "denied",
                        message: rejection.status === 401
                            ? "Your session has expired. Please sign in again."
                            : "You do not have permission to access this resource. Please sign in with proper credentials."
                    };

                    this._stateSvc.go(NotAuthorizedState, params);
                    return Promise.reject(rejection);
                }

                // Fallback: Use direct window redirect
                const reason = rejection.status === 401 ? "expired" : "denied";
                window.location.href = `/tb-login?reason=${reason}`;
            } catch (error) {
                this._logSvc.error("Error redirecting to login:", error);
                window.location.href = "/tb-login?reason=access_denied";
            }
        }

        return Promise.reject(rejection);
    }
    
    static factory($log, $state, TbAppConfigDataService) {
        return new IdTokenClaimsInterceptor($log, $state, TbAppConfigDataService);
    }
}

IdTokenClaimsInterceptor.$inject = [
    "$log",
    "$state",
    "TbAppConfigDataService"
];

IdTokenClaimsInterceptor.dependencies = [
    UiRouterModule,
    TbAppConfigDataServiceModule
];

export default IdTokenClaimsInterceptor;



//////////////////
// WEBPACK FOOTER
// ./src/services/auth/IdTokenClaimsInterceptor.js
// module id = YW9g
// module chunks = 1